import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { StoreProptypes } from "../../PropTypes/StoreProptypes";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface PropTypes {
    setIsOpenCloseWidgetTrigger: Function // function to toggle custom trigger
}

// component to render widget custom trigger
const VoiceTrigger = (props: PropTypes) => {

    // Props
    const { setIsOpenCloseWidgetTrigger } = props;

    // Redux Data
    const { currentWebsite } = useSelector((store: StoreProptypes) => store);
    console.log('currentWebsite: ', currentWebsite);

    // Functions
    const { t } = useTranslation();

    // Stets
    const [customTrigger, setCustomTrigger] = useState<boolean>(false);

    // Set current widget icon type
    useEffect(() => {
        // check if current website is available
        if (currentWebsite) {
            // check if custom trigger is turned On
            if (currentWebsite.is_sound_disabled) {
                setCustomTrigger(currentWebsite.is_sound_disabled);
            }
        }
    }, [currentWebsite]);



    // set current statement link in prop function
    useEffect(() => {
        setIsOpenCloseWidgetTrigger(customTrigger);
    }, [customTrigger]);

    return (
        <>
            <div className="aioa_dashboard-widget-settings-controls">
                <div className={customTrigger ? "aioa_dashboard-widget-custom-settings" : ''}>
                    <Form.Check
                        type="switch"
                        className="aioa_dashboard-switch"
                        id="custom-trigger-switch"
                        label={`${t('Enable Open Close sound on Widget')}`}
                        checked={customTrigger}
                        onChange={(e) => setCustomTrigger(!customTrigger)}
                    />
                </div>
            </div>
        </>
    )
}

export default VoiceTrigger;